module.exports = __webpack_public_path__ + "img/2188f17ee882cccbc6d546618c7ca025.png";